function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Settings/Green/Bold");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Settings/Green/Bold",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 1.000000)",
  fill: "#155C28",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.2625,11.05 L30.6,6.5875 L27.625,3.6125 L23.1625,5.95 C22.525,5.525 21.675,5.3125 20.825,5.1 L19.125,0 L14.875,0 L13.175,4.8875 C12.5375,5.1 11.6875,5.3125 11.05,5.7375 L6.5875,3.4 L3.4,6.5875 L5.7375,11.05 C5.3125,11.6875 5.1,12.5375 4.8875,13.175 L0,14.875 L0,19.125 L4.8875,20.825 C5.1,21.675 5.525,22.3125 5.7375,23.1625 L3.4,27.625 L6.375,30.6 L10.8375,28.2625 C11.475,28.6875 12.325,28.9 13.175,29.1125 L14.875,34 L19.125,34 L20.825,29.1125 C21.675,28.9 22.3125,28.475 23.1625,28.2625 L27.625,30.6 L30.6,27.625 L28.2625,23.1625 C28.6875,22.525 28.9,21.675 29.1125,20.825 L34,19.125 L34,14.875 L29.1125,13.175 C28.9,12.5375 28.6875,11.6875 28.2625,11.05 Z M17,23.375 C13.3875,23.375 10.625,20.6125 10.625,17 C10.625,13.3875 13.3875,10.625 17,10.625 C20.6125,10.625 23.375,13.3875 23.375,17 C23.375,20.6125 20.6125,23.375 17,23.375 Z",
  id: "Shape"
})));

var SvgSettingsActiveIcon = function SvgSettingsActiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsActiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-active-icon.ea825314.svg";
export { ForwardRef as ReactComponent };